import "./index.css";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
var SearchInput = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    placeholder = _ref.placeholder,
    onKeyDown = _ref.onKeyDown,
    inputRef = _ref.inputRef,
    searchPageUrl = _ref.searchPageUrl,
    autocomplete = _ref.autocomplete,
    _ref$LinkComponent = _ref.LinkComponent,
    LinkComponent = _ref$LinkComponent === void 0 ? Link : _ref$LinkComponent;
  var _a;
  return jsxs("div", Object.assign({
    ref: ref,
    className: classNames('cds-search-input', className)
  }, {
    children: [jsx("input", Object.assign({
      ref: inputRef,
      className: "cds-search-input__textfield",
      placeholder: placeholder,
      onKeyDown: onKeyDown
    }, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
      placeholder: placeholder,
      onKeyDown: onKeyDown
    }))), ((_a = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.autocompleteState) === null || _a === void 0 ? void 0 : _a.isOpen) && (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.autocompleteState.collections.map(function (_ref2) {
      var items = _ref2.items;
      return jsx("ul", Object.assign({
        className: "cds-search-input__autocomplete"
      }, {
        children: items.map(function (item) {
          return jsx(LinkComponent, Object.assign({
            className: "cds-search-input__autocomplete-item",
            href: "".concat(searchPageUrl, "?q=").concat(item.label),
            variant: "nav"
          }, {
            children: item.label
          }), item.label);
        })
      }));
    }))]
  }));
});
export { SearchInput };